import * as React from "react";
import {
  Backdrop,
  CircularProgress,
  Grid,
  Link,
  Typography,
} from "@mui/material";

import DataGridComponent from "../../components/DataGridComponent";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { DeleteOutline, ModeEditOutlineOutlined } from "@mui/icons-material";
import { useTheme } from "@emotion/react";
import { toast } from "react-toastify";
import { CATEGORY_DELETE_RESET } from "../../constants/categoryConstants";
import { deletecategory, listcategory } from "../../actions/categoryActions";
import { deleteAttribute, listAttributes } from "../../actions/attributeActions";
import { ATTRIBUTE_DELETE_RESET } from "../../constants/attributeConstants";

export default function ListAttributes() {
  const { palette } = useTheme();
  const columns = [
    {
      field: "_id",
      headerName: "ID",
      width: 200,
      renderCell: (params) => {
        return <> {params.row._id} </>;
      },
    },
    {
      field: "name",
      width: 200,
      headerName: "Name",
      renderCell: (params) => {
        return <> {params.row.name} </>;
      },
    },

    {
      field: "status",
      headerName: "Active",
      width: 200,
      renderCell: (params) => {
        return (
          <>
            {" "}
            {params.row.status ? (
              <Typography variant="body2" color="primary">
                Active
              </Typography>
            ) : (
              <Typography variant="body2" color="red">
                Not Active
              </Typography>
            )}
          </>
        );
      },
    },
    {
      field: "action",
      headerName: "Action",
      width: 200,
      renderCell: (params) => {
        return (
          <>
            <Link href={`/attribute/${params.row._id}`}>
              <ModeEditOutlineOutlined
                style={{
                  color: palette.primary.main,
                  cursor: "pointer",
                  marginRight: "10px",
                }}
              />
            </Link>
            <DeleteOutline
              className="delIcon"
              sx={{
                cursor: "pointer",
                color: palette.error.main,
              }}
              onClick={() => handleDelete(params.row._id)}
            />
          </>
        );
      },
    },
  ];

  const dispatch = useDispatch();

  const attributeList = useSelector((state) => state.attributeList);
  const { loading, error, attributes } = attributeList;

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const attributeDelete = useSelector((state) => state.attributeDelete);
  const { success } = attributeDelete;

  React.useEffect(() => {
    dispatch(listAttributes());
    if (!userInfo) {
      navigate("/", { replace: true });
    }
    if (success) {
      toast("Attribute deleted successfully");
      dispatch({ type: ATTRIBUTE_DELETE_RESET });
    }
  }, [dispatch, userInfo, success]);

  const navigate = useNavigate();

  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete the Attribute?")) {
      dispatch(deleteAttribute(id));
    }
  };
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={12}>
        {loading && (
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={true}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        )}

        {error && (
          <Typography variant="h6" color="error">
            {error}
          </Typography>
        )}

        {attributes && (
          <DataGridComponent
            buttonTitle={"Add Attribute"}
            onClick={() => navigate("/createAttribute")}
            title={"Attributes List"}
            columns={columns}
            rows={attributes}
          />
        )}
      </Grid>
    </Grid>
  );
}
